"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledReactTooltip = void 0;
var styled_components_1 = require("styled-components");
var react_tooltip_1 = require("react-tooltip");
exports.StyledReactTooltip = styled_components_1.default(react_tooltip_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  opacity: initial !important;\n  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.25);\n  padding: 0 !important;\n  border-radius: initial !important;\n  border: none !important;\n"], ["\n  opacity: initial !important;\n  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.25);\n  padding: 0 !important;\n  border-radius: initial !important;\n  border: none !important;\n"])));
var templateObject_1;
//# sourceMappingURL=styles.js.map